import { Toaster } from 'sonner'
import { useTheme } from '@/lib/theme'

/**
 * 跟随主题的 sonner Toaster。
 *
 * sonner 自己生成内联样式，`theme` 属性是它唯一认主题的开关 —— 写死 `"dark"` 会让浅色主题下
 * 的提示条沿用深色文字/阴影，是最容易漏掉的一处。这里取解析后的主题传给它；
 * 其余样式仍走令牌（`toastOptions.style`），会随 :root/.dark 自动变。
 *
 * ⚠️ 本文件与另一端 frontend 的同名文件刻意保持相同，改动请同步。
 */
export function ThemedToaster() {
  const { resolved } = useTheme()

  return (
    <Toaster
      theme={resolved}
      position="top-right"
      toastOptions={{
        style: {
          background: 'var(--color-card)',
          border: '1px solid var(--color-border)',
          color: 'var(--color-card-foreground)',
        },
      }}
    />
  )
}
